import { create } from 'zustand'

const useViewStore = create((set, get) => ({
    isLargeDesktopView: window.innerWidth >= 1800,
    isDesktopView: window.innerWidth >= 1200,
    isPadView: window.innerWidth < 992,
    isMobileView: window.innerWidth < 768,

    setView: () => set(() => ({
        isLargeDesktopView: window.innerWidth >= 1800,
        isDesktopView: window.innerWidth >= 1200,
        isPadView: window.innerWidth < 992,
        isMobileView: window.innerWidth < 768
    })),
}))

export default useViewStore;